import dayjs from 'dayjs'
import { getRoomTypesApi } from '@/api/priceSign'
// import priceSign2026TestData from '@/utils/priceSign2026TestData'
// 横屏竖屏可选择背景
const defaultBgImageKeys = ['blue', 'orange', 'gray', 'black']
export default {
  /**
   * 获取酒店房型信息
   * roomTypeConfList 显示的房型列表，如果为空则显示所有房型
   */
  async getRoomTypes(hotelId, roomTypeConfList, screenType) {
    const useRoomTypes = []
    const data = await getRoomTypesApi(hotelId, screenType)
    // const data = priceSign2026TestData.getRoomTypesApiTest(hotelId)
    if (data.code !== 0) {
      return useRoomTypes
    }
    // 原始房型列表
    const originRoomTypes = data.data
    for (let index = 0; index < originRoomTypes.length; index++) {
      const item = originRoomTypes[index]
      const useRoomType = this.getUseRoomTypeInfo(item, roomTypeConfList)
      if (useRoomType != null) {
        useRoomTypes.push(useRoomType)
      }
    }
    return useRoomTypes
  },

  /**
   * 获取使用的房型信息
   * roomTypeConfList 显示的房型列表，如果为空则显示所有房型
   */
  getUseRoomTypeInfo(roomType, roomTypeConfList) {
    let roomTypeConf = null
    // roomTypeConfList 不为空时，只有包含在列表中的房型才可用；为空则不做判断，直接进入下一步判断
    if (roomTypeConfList && roomTypeConfList.length > 0) {
      roomTypeConf = roomTypeConfList.find(
        (item) => item.roomTypeId === roomType.id
      )
      if (!roomTypeConf) {
        return null
      }
    }
    const roomTypeTodayInfo = roomType.prices[0]
    if (roomTypeTodayInfo.totalRoomCount <= 0) {
      return null
    }
    const newRoomType = {}
    newRoomType.id = roomType.id
    newRoomType.roomTypeName =
      roomTypeConf?.roomTypeName || roomType.roomTypeName
    // 门市价
    newRoomType.marketPrice = roomType.price
    // 销售群
    newRoomType.salePrice = roomTypeTodayInfo.price
    newRoomType.full = roomTypeTodayInfo.currentRoomCount === 0
    newRoomType.cover = roomType.imgNames ? roomType.imgNames.split('|')[0] : ''
    return newRoomType
  },

  /**
   * 初始化配置信息
   */
  async getShowInfo(
    originConfigInfo,
    roomTypes,
    roomTypesDiscount,
    memberLevels,
    standardHeight,
    screenType
  ) {
    // 如果顶部占比没有配置，那么是老配置，需要设置默认配置
    if (originConfigInfo.topBarProportion == null) {
      this.initDefaultConfig(originConfigInfo)
    }

    this.countShowFontSize(originConfigInfo, standardHeight)
    // 获取一下svg
    // 如果是显示酒店名，那么获取icon svg
    if (originConfigInfo.hotelNameShowType === 0) {
      // icon显示大小
      originConfigInfo.hoteIconSize = originConfigInfo.hotelNameSize * 1.1
      originConfigInfo.hotelIconSvg = await this.getHolteIconSvg(
        originConfigInfo.hoteIconSize,
        originConfigInfo.hotelNameColor
      )
    }
    // 背景图
    this.initBackgroundImageInfo(originConfigInfo)
    // 透明度颜色
    this.initRgbaColor(originConfigInfo)
    // （0：系统价，1：会员最低价，2：1级会员，3：2级会员，4：3级会员，5：4级会员，6：5级会员）
    let priceTypes = originConfigInfo.showPrice.split(',')
    // 如果配置的时候要显示最高会员级别价格，后来不使用最高等级了，就不用显示了
    const maxLevelPricType = '6'
    if (priceTypes.includes(maxLevelPricType) && memberLevels.length === 4) {
      priceTypes = priceTypes.filter((item) => item !== maxLevelPricType)
    }
    // 获取显示的价格类型名
    const priceTypeNames = this.getPriceTypeNames(
      priceTypes,
      memberLevels,
      originConfigInfo
    )
    // 房型显示的价格
    this.initRoomTypePrices(roomTypes, roomTypesDiscount, priceTypes)
    // 每页显示几个房型 默认6个
    const pageShowCount = originConfigInfo.displayRows
    const roomTypePages = Array.from(
      { length: Math.ceil(roomTypes.length / pageShowCount) },
      (v, i) =>
        roomTypes.slice(i * pageShowCount, i * pageShowCount + pageShowCount)
    )
    return {
      priceTypeNames,
      roomTypePages,
      configInfo: originConfigInfo
    }
  },

  initDefaultConfig(config) {
    config.hotelLogoRadius = 10
    config.hotelNameBackgroundColor = '#FFFFFF'
    config.hotelNameBackgroundRadius = 100
    config.hotelNameBackgroundTransparency = 70
    if (config.screenType === 0) {
      this.initHorizontalDefaultConfig(config)
      return
    }
    this.initVerticalDefaultConfig(config)
  },

  initHorizontalDefaultConfig(config) {
    config.topBarProportion = 0.12
    config.bottomBarProportion = config.screenWidth = config.notice
      ? 0.09
      : 0.045
  },

  initVerticalDefaultConfig(config) {
    config.topBarProportion = 0.09
    config.bottomBarProportion = config.notice ? 0.08 : 0.03
  },

  /**
   * 没有数据的设置默认数据
   * 电子房价牌新增的字段，原来可能没有，所以需要设置默认数据
   */
  initDefaultDataToNoData(config) {
    //
    // if(!config.hotelNameBackgroundColor){
    // }
    // // 酒店名背景色
    // config.hotelNameBackgroundColorRgba = this.hexToRgba(
    //   config.hotelNameBackgroundColor,
    //   1 - config.hotelNameBackgroundTransparency / 100
    // )
    // // 房型整体背景类型时标题背景色
    // config.roomTypeTitleBackgroundColorRgba = priceSignPreviewUtil.hexToRgba(
    //   config.roomTypeBackgroundColor,
    //   1 - config.titleTransparency / 100
    // )
    // // 房型整体背景类型时内容背景色
    // config.roomTypeContentBackgroundColorRgba = priceSignPreviewUtil.hexToRgba(
    //   config.roomTypeBackgroundColor,
    //   1 - config.contentTransparency / 100
    // )
    // // 交替行背景色
    // config.zebraStripingColorRgba = priceSignPreviewUtil.hexToRgba(
    //   config.zebraStripingColor,
    //   1 - config.zebraStripingTransparency / 100
    // )
  },

  /**
   *
   * @returns 获取图片icon svg
   */
  async getHolteIconSvg(hoteIconSize, hotelNameColor) {
    try {
      const svgPath = require('@/assets/images/priceSign/hotel_icon.svg')
      const res = await fetch(svgPath)
      let svgText = await res.text()
      svgText = svgText
        .replace(/width="[^"]*"/g, hoteIconSize)
        .replace(/height="[^"]*"/g, hoteIconSize)
        .replace(/fill="[^"]*"/g, `fill=${hotelNameColor}`)
      return svgText
      // svgText = svgText
      //   .replace(/width="[^"]*"/g, "")
      //   .replace(/height="[^"]*"/g, "");
      // return svgText.replace(/fill="[^"]*"/g, `fill="${hotelNameColor}"`);
      // 如果你还需要改 stroke，可以加一行：
      // .replace(/stroke="[^"]*"/g, `stroke="${color.value}"`)
      // return svgText
      //   .replace(/width="[^"]*"/g, "")
      //   .replace(/height="[^"]*"/g, "")
      //   .replace(/fill="[^"]*"/g, 'fill="currentColor"');
    } catch (error) {
      console.error('error123', error)
      return ''
    }
  },

  /**
   * 背景图
   */
  initBackgroundImageInfo(config) {
    // 判断原来配置的是默认图片还是自定义
    if (defaultBgImageKeys.includes(config.backgroundImageUrl)) {
      config.bgImageKey = config.backgroundImageUrl
      return
    }
    config.bgImageKey = 'custom'
  },

  /**
   * 获取透明度
   */
  getTransparency(value) {
    const decimal = 255
    const hexadecimal = Math.floor((decimal * (100 - value)) / 100).toString(16)
    return hexadecimal
  },

  /**
   * 初始化透明度颜色
   */
  initRgbaColor(config) {
    config.hotelNameBackgroundColorRgba = this.hexToRgba(
      config.hotelNameBackgroundColor,
      1 - config.hotelNameBackgroundTransparency / 100
    )
    // 房型整体背景类型时标题背景色
    config.roomTypeTitleBackgroundColorRgba = this.hexToRgba(
      config.roomTypeBackgroundColor,
      1 - config.titleTransparency / 100
    )
    // 房型整体背景类型时内容背景色
    config.roomTypeContentBackgroundColorRgba = this.hexToRgba(
      config.roomTypeBackgroundColor,
      1 - config.contentTransparency / 100
    )
    // 交替行背景色
    config.zebraStripingColorRgba = this.hexToRgba(
      config.zebraStripingColor,
      1 - config.zebraStripingTransparency / 100
    )
  },

  /**
   * 十六进制颜色转RGBA
   * @param {string} hex 十六进制颜色，支持 #fff 或 #ffffff 格式
   * @param {number} alpha 透明度，0-1之间
   * @returns {string} RGBA字符串
   */
  hexToRgba(hex = '#ffffff', alpha = 0) {
    // 安全校验：处理 null/undefined/非字符串情况
    if (!hex || typeof hex !== 'string' || !hex.startsWith('#')) {
      hex = '#ffffff'
    }
    // 确保是有效的 hex 格式（长度为 4 或 7）
    if (hex.length !== 4 && hex.length !== 7) {
      hex = '#ffffff'
    }
    // 安全校验 alpha 参数：必须在 0-1 范围内，默认为 0
    if (alpha === null || alpha === undefined || typeof alpha !== 'number') {
      alpha = 0
    } else {
      // 限制在 0-1 范围内
      alpha = Math.max(0, Math.min(1, alpha))
    }
    // 处理简写格式（#fff → #ffffff）
    const fullHex =
      hex.length === 4 ? hex.replace(/(\w)(\w)(\w)/, '$1$1$2$2$3$3') : hex

    // 提取R、G、B分量并转十进制
    const r = parseInt(fullHex.slice(1, 3), 16)
    const g = parseInt(fullHex.slice(3, 5), 16)
    const b = parseInt(fullHex.slice(5, 7), 16)

    // 返回RGBA字符串
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  },

  /**
   * 获取显示的价格名
   */
  getPriceTypeNames(priceTypes, memberLevels, configInfo) {
    const priceTypeNames = []
    priceTypes.forEach((priceType) => {
      priceTypeNames.push(
        this.getPriceTypeName(parseInt(priceType), memberLevels, configInfo)
      )
    })
    return priceTypeNames
  },

  /**
   * 获取价格名
   */
  getPriceTypeName(priceType, memberLevels, configInfo) {
    // 门市价
    if (priceType === -1) {
      return configInfo.marketPriceName || '门市价'
    }
    // 销售价
    if (priceType === 0) {
      return configInfo.salePriceName || '销售价'
    }
    // 最低价返回会员最高等级的折扣
    if (priceType === 1) {
      return configInfo.memberMinPriceName || '会员最低价'
    }
    // 其余都是会员级别
    const levelIndex = priceType - 2
    // 如果配置了的级别关闭了，那么返回-1不显示
    if (levelIndex > memberLevels.length - 1) {
      return null
    }
    const memberLevel = memberLevels[levelIndex]
    return memberLevel.levelName
  },

  /**
   *
   * @param {价格类型} priceType
   * @param {会员级别信息} memberLevels
   * @returns 房型使用的价格配置
   */
  getRoomTypeDiscountInfo(priceType, memberLevels) {
    // 其余都是会员级别
    const levelIndex = priceType - 2
    // 如果配置了的级别关闭了，那么返回-1不显示
    if (levelIndex > memberLevels.length - 1) {
      return null
    }
    const memberLevel = memberLevels[levelIndex]
    return {
      discountType: memberLevel.discountType,
      discount: memberLevel.discount,
      name: memberLevel.levelName
    }
  },

  /**
   *
   * @param {门市价} marketPrice
   * @param {销售价} salePrice
   * @param {价格类型} priceType
   * @param {全部折扣信息} roomTypeDiscounts
   * 根据价格类型获取价格
   */
  getPriceWithPriceType(marketPrice, salePrice, priceType, roomTypeDiscounts) {
    // 门市价
    if (priceType === -1) {
      return marketPrice
    }
    // 销售价
    if (priceType === 0) {
      return salePrice
    }
    // 最低价
    if (priceType === 1) {
      return this.getRoomTypeLowestPrice(salePrice, roomTypeDiscounts)
    }
    // 会员折扣
    const discountInfo = this.getRoomTypeDiscountInfo(
      priceType,
      roomTypeDiscounts
    )
    return this.getRoomTypeDiscountPrice(salePrice, discountInfo)
  },

  /**
   * 获取房型的折扣价
   * @param {销售价} salePrice
   * @param {折扣信息} disCountInfo
   */
  getRoomTypeDiscountPrice(salePrice, disCountInfo) {
    return disCountInfo.discountType === 0
      ? Math.floor(salePrice * disCountInfo.discount)
      : Math.floor(salePrice + disCountInfo.discount)
  },

  /**
   * 获取房型最低价
   */
  getRoomTypeLowestPrice(salePrice, roomTypeDiscounts) {
    let lowestPrice = salePrice
    for (let index = 0; index < roomTypeDiscounts.length; index++) {
      const item = roomTypeDiscounts[index]
      // 折扣价
      const discountPrice = this.getRoomTypeDiscountPrice(salePrice, item)
      if (discountPrice < lowestPrice) {
        lowestPrice = discountPrice
      }
    }
    return lowestPrice
  },

  /**
   * 获取房型显示的价格
   * 显示的价格类型
   * 房型列表
   * 价格列表
   */
  initRoomTypePrices(roomTypes, hotelRoomTypesDiscount, priceTypes) {
    for (let index = 0; index < roomTypes.length; index++) {
      const roomType = roomTypes[index]
      // 房型所有价格
      const prices = []
      roomType.prices = prices
      priceTypes.forEach((priceType) => {
        prices.push(
          this.getPriceWithPriceType(
            roomType.marketPrice,
            roomType.salePrice,
            parseInt(priceType),
            hotelRoomTypesDiscount[roomType.id]
          )
        )
      })
    }
  },

  /**
   * 当前时间
   */
  getCurrentTime() {
    const date = new Date().getTime()
    const day = dayjs(date).format('YYYY年MM月DD日')
    const time = dayjs(date).format('HH:mm')
    let dayOfWeek
    const num = dayjs(date).day()
    switch (num) {
      case 0:
        dayOfWeek = '周天'
        break
      case 1:
        dayOfWeek = '周一'
        break
      case 2:
        dayOfWeek = '周二'
        break
      case 3:
        dayOfWeek = '周三'
        break
      case 4:
        dayOfWeek = '周四'
        break
      case 5:
        dayOfWeek = '周五'
        break
      case 6:
        dayOfWeek = '周六'
        break
    }
    return { day, dayOfWeek, time }
  },

  /**
   * 计算显示字体大小
   */
  countShowFontSize(config, standardHeight) {
    const windowHeight = window.innerHeight
    const ratio = windowHeight / standardHeight
    // 酒店名文字大小
    config.hotelNameSize = config.hotelNameSize * ratio
    // 时间文字大小
    config.timeSize = config.timeSize * ratio
    // 标题文字字号 Integer
    config.titleSize = config.titleSize * ratio
    // 房型文字字号 Integer
    config.roomTypeSize = config.roomTypeSize * ratio
    // 满房字体大小
    config.fullSize = (config.roomTypeSize * 2) / 3
    // 房价文字字号 Integer
    config.roomPriceSize = config.roomPriceSize * ratio
    // 公告文字大小
    config.noticeSize = config.noticeSize * ratio
  }
}
